<template>
    <v-card id="mapconteiner" elevation="8" class="ma-5 mt-10" style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
        <v-container class="size" fluid>
            <v-layout row justify-start>
                 <v-flex lg12 md12 sm12 xs12 pa-1>
                    <v-layout row justify-start>
                        <v-flex xs12 md12 pl-2>
                            <h3><b>Capacidade de alojamento</b></h3>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-start class="pl-2">
                        <v-flex class="item" lg2 md2 sm6 xs12 pa-1>
                            <v-autocomplete v-on:keyup.enter="loadAlojamento" v-model="csTipoUEP" :items="listaTipoUEP"
                                color="primary" item-text="dsTipoUEP" item-value="csTipoUEP" label="Tipo de Unidade Exploração"
                                no-data-text="Nenhum registro" outlined clearable>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex class="item" lg2 md2 sm2 xs12 pt-5>
                            <v-checkbox color="info" style="margin: 0px;" v-model="flExibeTodosMunicipios" label="Exibe todos os municípios" ></v-checkbox>
                        </v-flex>
                        <v-flex class="item" lg2 md2 sm2 xs12 pa-2>
                            <v-btn id="search" dark rounded color="primary" @click="loadAlojamento">
                                <span class="marginSpan"> Atualizar </span>
                                <v-icon small>fa-sync-alt</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <div style="height: 500px;" id="mapdiv"></div>
                    <v-layout row wrap justify-start v-if="$vuetify.breakpoint.smAndUp" class="pl-2">
                        <v-flex class="item" lg12 md12 sm12 xs12 pa-1>
                            <v-data-table :headers="headersEstabelecimento" @click:row="goToEstabelecimento"
                                no-results-text="Nenhum registro encontrado" :must-sort="true" :items="estabelecimentos" color="secondary"
                                loading-text="Carregando registros...aguarde">
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>



<script>
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster"
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import chroma from "chroma-js"
import axios from "axios"

const offStyle = {
    color: "grey",
    weight: 1,
    fill: true,
    opacity: 1,
    fillOpacity: 0
};

const onStyle = {
    color: "grey",
    weight: 1,
    fill: true,
    opacity: 1,
    fillOpacity: 0.3
};

export default {
    data() {
        return {
            min: 0,
            max: 100,
            mapLayerControl: null,
            map: null,
            info: null,
            pontos: null,
            cities: null,
            cityCodes: [],
            objMarkers: [],
            flExibeTodosMunicipios: false,
            estabelecimentos: [],
            headersEstabelecimento: [
                { text: 'Identificador', value: 'idEstabelecimento' },
                { text: 'Nome', value: 'nmEstabelecimento' },
                { text: 'Código Oficial', value: 'nrCodigoOficial' },
                { text: 'Localidade', value: 'nmLocalidade' },
                { text: 'Município', value: 'nmMunicipio' },
                { text: 'Capacidade', value: 'nrCapacidade' },
                { text: 'Total de UEPs', value: 'qtUeps' },
            ],  
            listaTipoUEP: [
                {
                    csTipoUEP: 'CR',
                    dsTipoUEP: 'Creche'
                },
                {
                    csTipoUEP: 'TR',
                    dsTipoUEP: 'Terminação'
                },
                {
                    csTipoUEP: 'WF',
                    dsTipoUEP: 'Wean to Finish'
                },
                {
                    csTipoUEP: 'UP',
                    dsTipoUEP: 'UPL'
                }
            ],
            csTipoUEP: ''
        }
    },
    computed: {
        urlAPIEstabelecimento() {
            return this.$store.state.urlAPIEstabelecimento
        },
    },
    mounted() {
        this.initComponent()
    },
    methods: {
        initComponent() {
            this.initMap()
            this.loadAlojamento()
        },
        initMap() {
            this.map = L.map("mapdiv", {
                center: [-27.019984, -51.064453],
                zoom: 7,
                worldCopyJump: true
            })
            this.mapLayerControl = L.control.layers({}, {}).addTo(this.map)

            var openStreetLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', 
                {
                    maxZoom: 12,
                    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' + 
                    '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
                })

            var streetBasicsLayer = L.tileLayer(
                "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw",
                {
                    maxZoom: 18,
                    attribution:
                        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
                        '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                        'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                    id: "mapbox.streets-basic"
                }
            ).addTo(this.map)

            this.cities = L.geoJSON().addTo(this.map)

            this.info = L.control()

            this.info.onAdd = function(map){
                this._div = L.DomUtil.create('div', 'legenda')
                this.update()
                return this._div
            }

            this.info.update = function(element) {
                this._div.innerHTML = "<h4> Capacidade de Alojamento </h4>" + (element ? 
                    '<b>' + element.nmMunicipio + '</b><br/>' + element.nrTotal + ' animais' : 
                    'Selecione uma cidade')
            }

            this.info.addTo(this.map)

            this.mapLayerControl.addBaseLayer(streetBasicsLayer, "Básico")
            this.mapLayerControl.addBaseLayer(openStreetLayer, "Detalhado")
            this.mapLayerControl.addOverlay(this.cities, "Divisões Geográficas")
        },
        loadMash(dadosAlojamento, scale) {
            this.cities.clearLayers()
            axios.get(`https://servicodados.ibge.gov.br/api/v2/malhas/4?formato=application/vnd.geo+json`, {
                    params: {
                        resolucao: 5
                    }
                })
                .then(response => {
                    var layerData = L.geoJSON(response.data, {
                        style: () => {
                            return offStyle
                        },
                        pane: "tilePane",
                        filter: (feature) => {
                            if (this.flExibeTodosMunicipios)
                            {
                                return true
                            }
                            let alojados = dadosAlojamento.find(x => x.cdMunicipio.toString() == feature.properties.codarea)
                            if (alojados != undefined)
                            {
                                return true
                            }
                            return false
                        },
                        onEachFeature: (feature, layer) => {
                            let alojados = dadosAlojamento.find(x => x.cdMunicipio.toString() == feature.properties.codarea)
                            if (alojados != undefined)
                            {
                                var style = {
                                    fillColor: this.getColor(alojados.nrTotal),
                                    weight: 1,
                                    fill: true,
                                    opacity: 1,
                                    fillOpacity: 0.5
                                }

                                layer.setStyle(style)

                                var text = "<h4>" + alojados.nmMunicipio + "<br/>" + 
                                    alojados.nrTotal.toString() + " animais</h4>"
                                layer.bindTooltip(text)

                                layer.alojados = alojados

                                layer.on("mouseover", layer => {
                                    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
                                        layer.target.bringToFront()
                                    }
                                    
                                    var style = {
                                        fillColor: this.getColor(alojados.nrTotal),
                                        weight: 5,
                                        fill: true,
                                        opacity: 1,
                                        fillOpacity: 0.5
                                    }

                                    layer.target.setStyle(style)
                                    this.info.update(layer.target.alojados)
                                })
                                layer.on("mouseout", layer => {
                                    var style = {
                                        fillColor: this.getColor(alojados.nrTotal),
                                        weight: 1,
                                        fill: true,
                                        opacity: 1,
                                        fillOpacity: 0.5
                                    }

                                    layer.target.setStyle(style)

                                    this.info.update()
                                })
                                layer.on("click", layer => {
                                    this.map.flyToBounds(layer.target.getBounds())
                                    this.getEstabelecimentos(layer.target.alojados.cdMunicipio)
                                })
                            }
                        }
                    })
                    this.cities.addLayer(layerData)

                    this.map.fitBounds(this.cities.getBounds())
                })
                .catch(error => {
                    this.$store.commit("setSnack", { type: "error", msg: error })
                })
        },
        goToEstabelecimento(estabelecimento) {
            this.$router.push({name: 'estabelecimento', params: {id: estabelecimento.idEstabelecimento}})
        },
        getEstabelecimentos(cdMunicipio) {
            var context = this
            this.$axios.get(this.urlAPIEstabelecimento + 'analises/alojamento/detalhes/', {
                params: {
                    csTipoUnidadeExploracao: this.csTipoUEP != '' ? this.csTipoUEP : null,
                    cdMunicipio: cdMunicipio
                }
            })
            .then((response) => {
                context.estabelecimentos = response.data
            })
            .catch((error) => {
                context.$store.commit("setSnack", { type: "error", msg: error })
            })
        },
        getColor(nrTotal){
            return this.scale(nrTotal).hex()
        },
        loadAlojamento() {
            var context = this;
            var dadosAlojamento = []
            this.$axios.get(this.urlAPIEstabelecimento + 'analises/alojamento/', {
                    params: {
                        csTipoUnidadeExploracao: this.csTipoUEP != '' ? this.csTipoUEP : null
                    }
                })
                .then((response) => {
                    context.objMarkers = []
                    var arrayTotal = []
                    response.data.forEach(p => {
                        arrayTotal.push(p.nrTotal)
                    })
                    this.scale = chroma.scale(['#FED976','#FEB24C','#FD8D3C','#FC4E2A','#E31A1C', '#BD0026', '#800026']).domain([Math.min.apply(Math, arrayTotal), Math.max.apply(Math, arrayTotal)], 7, 'quantiles')
                    context.loadMash(response.data)
                })
                .catch((error) => {
                    context.$store.commit("setSnack", { type: "error", msg: error })
                })
            }
        }
    };
</script>


<style>
#app {
  height: 100%;
  margin: 0;
}

#mapconteiner,
.size {
  height: 95%;
}
#mapdiv, #map {
    height: 93%;
    position: sticky !important;
}
.marginSpan {
    margin: 5px;
}
.legenda { 
    padding: 6px 8px; 
    font: 14px/16px Arial, Helvetica, sans-serif; 
    background: white; 
    background: rgba(255,255,255,0.8); 
    box-shadow: 0 0 15px rgba(0,0,0,0.2); 
    border-radius: 5px; 
} 
.legenda h4 { 
    margin: 0 0 5px;
    color: #777; 
}
</style>
